import React, { useState } from "react"
import DeleteModal from "../../../../components/Common/DeleteModal"
import { usePagination } from "../../../../hooks/usePagination"
import ResultHandler from "../../../../components/ResultHandler"
import PaginationHandler from "../../../../components/PaginationHandler"
import TableHeaderHandler from "../../../../components/TableHeaderHandler"
import { useTranslation } from "react-i18next"
import { useResponse } from "../../../../hooks/useResponse"
import TableAction from "../../../../components/TableAction"
import EmptyData from "../../../../components/EmptyData"
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { PERMISSIONS } from "../../../../api/permissions";
import { getContacts, deleteContact } from "../../../../api/contact"
import { useParams } from "react-router-dom"



export default function ContactsTable({hideTableAction, hideTableHeader}) {

  const { t } = useTranslation()

  const {id} = useParams()

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,

  } = usePagination(getContacts, {companyId: id})


  //// delete 
  const [show, setShow] = useState(false)

  function onCloseClick() {
    setShow(false)
  }

  const [deletingContact, setDeletingContact] = useState(null)

  const { setData } = useResponse(deleteContact, () => {
    setShow(false)
    setDeletingContact(null)
    setPayload({companyId: id})
  })

  function onDeleteClick() {
    setData({ type: "add", data: deletingContact })
  }



  return (
    <>
      {!hideTableHeader && <TableHeaderHandler
        permission={PERMISSIONS.EMPLOYEE_CREATE}
        setPage={setPage}
        setPerPage={setPerPage}
        addUrl="add-contact"
      >
       
      </TableHeaderHandler>}
   
      <div className="table-rep-plugin">
        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th>Name</Th>
                <Th>Phone</Th>
                <Th>Email</Th>
                <Th>Function</Th>

                {!hideTableAction && <Th style={{ width: "15%" }}>{t("tables.Action")}</Th>}
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.company_contacts.map(row => {
                  return (
                    <Tr key={row.id}>
                      <Td>{row.name}</Td>
                      <Td>{row.phoneNumber}</Td>
                      <Td>{row.email}</Td>
                      <Td>{row.function}</Td>

                      {!hideTableAction && <Td>
                        <TableAction
                          hasEdit={true}
                          hasDelete={true}
                          editPermission={PERMISSIONS.EMPLOYEE_EDIT}
                          deletePermission={PERMISSIONS.EMPLOYEE_DELETE}
                          type="contact"
                          id={row.id}
                          setShow={setShow}
                          setDeleteIntitiy={setDeletingContact}
                        />
                      </Td>}
                    </Tr>
                  )
                })}
              </Tbody>
            )}
          </Table>

          {!loading &&
            <EmptyData empty={response.data && response.data.company_contacts.length === 0} msg="No Contacts Found." />
          }
          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />


          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}


          <ResultHandler error={error} loading={loading} />

        </div>
      </div>
    </>
  )
}
